if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target, varArgs) { // .length of function is 2
      'use strict';
      if (target === null || target === undefined) {
        throw new TypeError('Cannot convert undefined or null to object');
      }

      var to = Object(target);

      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource !== null && nextSource !== undefined) { 
          for (var nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}






!function(t){var e={};function n(i){if(e[i])return e[i].exports;var a=e[i]={i:i,l:!1,exports:{}};return t[i].call(a.exports,a,a.exports,n),a.l=!0,a.exports}n.m=t,n.c=e,n.d=function(t,e,i){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:i})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var i=Object.create(null);if(n.r(i),Object.defineProperty(i,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var a in t)n.d(i,a,function(e){return t[e]}.bind(null,a));return i},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=0)}([function(t,e,n){n(1),t.exports=n(2)},function(t,e,n){"use strict";var i=function(){function t(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}return function(e,n,i){return n&&t(e.prototype,n),i&&t(e,i),e}}(),a=function(t,e){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return function(t,e){var n=[],i=!0,a=!1,r=void 0;try{for(var o,s=t[Symbol.iterator]();!(i=(o=s.next()).done)&&(n.push(o.value),!e||n.length!==e);i=!0);}catch(t){a=!0,r=t}finally{try{!i&&s.return&&s.return()}finally{if(a)throw r}}return n}(t,e);throw new TypeError("Invalid attempt to destructure non-iterable instance")};function r(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}jQuery(function(t){t(".open-nav-menu, .close-btn").on("click",function(){t("#myNav").toggleClass("opaque"),t("body").toggleClass("overflow-hidden")}),t(document).mouseup(function(e){var n=t(".main-search-form");n.is(e.target)||0!==n.has(e.target).length||(n.removeClass("show"),t(".search-link").removeClass("active"));var i=t("#videoBlogLightbox .open-video");0!==t("#shopify-section-video-blog-template").length&&0===i.has(e.target).length&&(t("#videoBlogLightbox").removeClass("open-video").find(".video-iframe").remove(),t("body").removeClass("overflow-hidden"))});var e=t(".recipes-slider");function n(){window.matchMedia("(min-width: 644px) and (max-width: 769px)").matches?(e.slick("unslick"),e.slick({dots:!1,infinite:!0,rows:2,speed:300,slidesToScroll:2,slidesToShow:2,nextArrow:'<span class="icon-next "></span>',prevArrow:'<span class="icon-prev"></span>'})):window.matchMedia("(max-width: 643px)").matches?(e.slick("unslick"),e.slick({dots:!1,infinite:!0,rows:2,speed:300,slidesToScroll:1,slidesToShow:1,nextArrow:'<span class="icon-next "></span>',prevArrow:'<span class="icon-prev"></span>'})):(e.slick("unslick"),e.slick({dots:!1,infinite:!0,speed:300,slidesToScroll:3,slidesToShow:3,nextArrow:'<span class="icon-next "></span>',prevArrow:'<span class="icon-prev"></span>'}))}function o(e,n){e.off("click").on("click",function(){t(window).width()<769&&(t(this).toggleClass("arrow_down"),t(this).parent().find(n).toggle("slow"))})}e.slick({dots:!1,infinite:!0,speed:300,slidesToScroll:3,slidesToShow:3,nextArrow:'<span class="icon-next "></span>',prevArrow:'<span class="icon-prev"></span>'}),n(),t(window).on("resize",function(){n()}),t(".dropdown-title").on("click",function(){t(this).next(".dropdown-content").toggleClass("dropdown-open")});var s=t(".aside__linklist > .aside__linklist-title"),c=t(".aside__linklist-item");o(s,c);var l=t(".js-show-menu"),u=t(".account__container-nav-list-item");o(l,u),t(window).on("resize",function(){t(window).width()>769?t(".dropdown-content").removeClass("dropdown-open"):(o(s,c),o(l,u))});var d=window.PF||{};d.QuantityCounter=function(){function e(t){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e);var n=t.input,i=t.value,a=t.min,r=t.step;this.input=n,this.parent=this.input.parents("[data-quantity-container]"),this.state={value:i,min:a,step:r},this.increment=this.increment.bind(this),this.decrement=this.decrement.bind(this),this.initHandler=this.initHandler.bind(this)}return i(e,[{key:"increment",value:function(){return this.state.value+=this.state.step,this.input.val(this.state.value),this.state.value}},{key:"decrement",value:function(){return this.state.value!==this.state.min&&(this.state.value-=this.state.step,this.input.val(this.state.value),this.state.value)}},{key:"initHandler",value:function(){var e=this;this.parent.find(".quantity__btn").on("click",function(n){if(n.preventDefault(),t(this).hasClass("js-quantity-inc"))e.increment();else{if(!t(this).hasClass("js-quantity-dec"))return!1;e.decrement()}})}}]),e}(),d.Quantity=function(){var e={$productQuantityInput:t('[name="quantity"]'),$cartQuantityInputs:t(".cart__qty-input")};function n(t){var e=t.data("quantity"),n=e?JSON.parse(e):{},i=n.min,a=n.step,r=t.val();return{input:t,min:Number(i)||1,step:Number(a)||1,value:Number(r)||1}}if(e.$cartQuantityInputs.length&&e.$cartQuantityInputs.each(function(){var e=n(t(this));new d.QuantityCounter(e).initHandler()}),e.$productQuantityInput.length){var i=n(e.$productQuantityInput);new d.QuantityCounter(i).initHandler()}}(),d.ThumbnailSlider=function(){var e={$thumbnailsSlider:t(".product-single__thumbnails")};function n(t){var n={slidesToShow:1,slidesToScroll:1,infinite:!1,prevArrow:".thumbnails-slider__prev",nextArrow:".thumbnails-slider__next"};!function(t){t.hasClass("slick-initialized")&&t.slick("unslick")}(e.$thumbnailsSlider),window.matchMedia("(min-width: 992px)").matches&&(n.slidesToShow=3),t.slick(n)}n(e.$thumbnailsSlider),t(window).on("resize",function(){n(e.$thumbnailsSlider)})}(),d.Tooltip=function(){var e=".selector-tooltip__content",n=".js-tooltip-btn";t(n).on("click",function(n){n.preventDefault(),t(this).parent().find(e).fadeToggle()}),t(document).on("click",function(i){var a=t(n);a.is(i.target)||t(i.target).closest(e).length||0!==a.has(i.target).length||t(e).fadeOut()})}(),d.Cart=function(){var e=t(".cart__qty-input"),n={};if(e.length){e.each(function(e,i){var a=t(i),r=a.data("qty-id"),o=JSON.parse(a.data("quantity")).min;Number(a.val())<Number(o)&&!n[r]&&(n[r]=o)}),Object.keys(n).length&&t.ajax({method:"POST",url:"/cart/update.js",dataType:"json",data:{updates:n}}).done(function(){if(!document.querySelector('[data-vacumm-sealing]'))window.location.reload()}).fail(function(t){console.error(t)});var i=setInterval(function(){t("#gs_modal input.address-street").length&&(function(){var e=/\bP(ost|ostal)?([ \\.]*O(ffice)?)?([ \\.]*Box)?\b/i,n=t("#gs_modal input.address-street"),i=t(".gs__custom-address .gs__address-complete");n.length&&n.on("blur",function(){e.test(this.value)?(t(this).addClass("error"),t(".address-error").length||t(".form.gs__custom-address").append('<span class="gs__form-error address-error">Sorry, we cannot ship to P.O. Boxes.</span>'),i.attr("disabled",!0)):(t(this).removeClass("error"),t(".gs__a-modal .form .address-error").remove(),i.attr("disabled",!1))})}(),clearInterval(i))},1e3)}}(),d.Collection=void t(".aside__linklist").each(function(){t(this).find("li").length<=1&&t(this).remove()}),d.Blogs=function(){var e={sidebarTitle:".js-sidebar-title",sidebarList:".blogs-sidebar__list",sidebarNav:".blogs-sidebar__nav"};return t(e.sidebarTitle).on("click",function(n){n.preventDefault(),function(){var n=t(this).parents(e.sidebarNav),i=n.find(e.sidebarList);n.hasClass("open")?(n.removeClass("open"),i.slideUp()):(n.addClass("open"),i.slideDown())}.call(this)}),{selectors:e}}(),d.Filter=function(){var e=[],n=[],i="constraint",r=function(t){if(""===t)return{};var e={};return t.slice(t.indexOf("?")+1).split("&").map(function(t){var n=t.split("="),i=a(n,2),r=i[0],o=i[1];return e[r]=decodeURIComponent(o),e}),e}(window.location.search),o={checkbox:".js-input-tag",paginationLink:".pagination li > a",listFilter:".blogs-sidebar__list-filter",listMainFilter:".recipes-hero__filter",listMainFilterInputs:".recipes-hero__filter input",mainFilterItem:".recipes-hero__filter-item"},s={listFilters:t(o.listFilter),listMainFilters:t(o.listMainFilter),listMainFilterInputs:t(o.listMainFilterInputs)};function c(t){window.location.href="?"+i+"="+t.join("+")}Object.assign(o,d.Blogs.selectors),s.listMainFilterInputs.each(function(){n.push(this.value)}),Object.keys(r).length&&r[i]&&(r[i].split("+").map(function(n){var i=t(o.checkbox+'[value="'+n+'"]');return e.push(n),i.prop("checked",!0).parents(o.mainFilterItem).addClass("active"),n}),function(e){var n=t(o.paginationLink),r="/?"+i+"="+e+"&";n.each(function(e,n){if(t(n).attr("href").indexOf("?")>-1){var i=t(n).attr("href").split("?"),o=a(i,2),s=o[0],c=o[1];t(n).attr("href",""+s+r+c)}})}(r[i])),t(o.checkbox).on("change",function(){var t=this.value;if(n.includes(t)){var i=n.filter(function(e){return e!==t});e=e.filter(function(t){return!i.includes(t)})}return e.includes(t)?(e.splice(e.indexOf(t),1),c(e),!0):!e.includes(t)&&(e.push(t),c(e),!0)}),s.listFilters.length&&s.listFilters.each(function(){t(this).find('input[type="checkbox"]:checked').length&&t(this).slideDown().parents(o.sidebarNav).addClass("open")})}(),d.GiftShip=function(){var e=".gs__cart-row .gs__item-title > a",n=[];function i(){var n=t(e),i=[];return!!n.length&&(n.each(function(){i.push(function(t){return-1===t.indexOf("/products/")?null:t.indexOf("?")>-1?t.split("?")[0].split("/products/")[1]:t.split("/products/")[1]}(t(this).attr("href")))}),i.filter(function(t){return null!==t}))}var a=function(t){return function(e){for(var n=void 0,i=0;i<t.length;i+=1)for(var a=0;a<t[i].variants.length;a+=1)if(t[i].variants[a].id===parseInt(e,10)){n=t[i];break}return n}};function r(e,n){var i=t("tr[data-variantid]"),r=a(e);i.each(function(){var e=t(this).data("variantid"),n=r(e).tags.includes("vacuum_seal_regular");t(this).parent().find(".gs__cart-remove").attr("data-vacuum-seal",n)}),n&&"function"==typeof n&&n()}function o(t){return n.find(function(e){return e.handle===t})}function s(e){var n=o(e);n&&n.variants.forEach(function(e){t("button[data-variantid="+e.id+"]").remove(),t(".gs__cart-row[data-variantid="+e.id+"]").parent().find(".gs__qty-wrapper").hide()})}function c(e,a){"function"==typeof e&&i().length&&Promise.all(i().map(function(e){return function(e){return new Promise(function(n,i){t.ajax({method:"GET",url:"/products/"+e+".js",dataType:"json"}).done(function(t){n(t)}).fail(function(t){return i(t)})})}(e)})).then(function(t){Object.assign(n,t),"function"==typeof a&&a()}).catch(function(t){return console.error(t)})}t(document).on("change",".gs__address-wrapper input.gs__search-input",function(){!function(){var e=t(".gs__address-wrapper input").val(),n="";if(o("vacuum-sealing").variants.map(function(t){return t.id}).forEach(function(e){n=t('.gs__cart-row[data-variantid="'+e.id+'"]')}),n&&""!==n.val()){var i=n.data("line");t.ajax({method:"POST",url:"/cart/change.js",data:{line:i,properties:{Address:e}}}).done(function(){n.find(".gs__address-wrapper input").val(e)}).fail(function(t){return console.error(t)})}}()}),c(c,function(){r(n),s("vacuum-sealing")}),function(t,e,n){var i=document.querySelector("#gsGroupsBox");if(i){var a=Object.assign({attributes:!0},{childList:!0,subtree:!0});new MutationObserver(function(t){t.forEach(function(t){"childList"===t.type&&n&&n()})}).observe(i,a)}}(0,0,function(){r(n),s("vacuum-sealing")}),t(document).on("click",".gs__add-shipping-address",function(){var e=t(this);t(document).ajaxComplete(function(i,r,o){if(o.url.indexOf("/cart/add.js")>-1){var s=e.data("variantid"),c=function(t){var e=void 0,n=t.filter(function(t){return/minimum_qty_\d+/.test(t)});return n.length&&(e=parseInt(n[0].match(/\d+/),10)),e||1}(a(n)(s).tags);t.ajax({method:"POST",url:"/cart/change.js",dataType:"json",data:{line:1,quantity:c}}).done(function(){if(!document.querySelector('[data-vacumm-sealing]'))window.location.reload()}).fail(function(t){return console.error(t)})}})}),t(document).on("click",".gs__cart-remove",function(){var e=t(this).is('[data-vacuum-seal="true"]');t(document).ajaxComplete(function(n,i,a){if(a.url.indexOf("/cart/change.js")>-1){var r=0===t('[data-vacuum-seal="true"]').length,o=t('a[href^="/products/vacuum-sealing"]'),s=o.parents("[data-variantid]").data("variantid");e&&r&&o.length&&t.ajax({method:"POST",url:"/cart/change.js",dataType:"json",data:{id:s,quantity:0}}).done(function(){if(!document.querySelector('[data-vacumm-sealing]'))window.location.reload()}).fail(function(t){return console.error(t)})}})}),t(document).on("change","#gsDeliveryDate",function(){var e=function(t){var e=t.trim().toLowerCase().split(/\s|-|\//gi),n=e[1].replace(/[^\d+]\w+/gi,"");return e[0]+" "+n+" "+e[2]}(this.value),n=new Date(e).getDay(),i=t(this).parents(".gs__field.gs__table-column");6===n?i.find("input[data-shipping-method-label-title]").each(function(){var e=t(this);/Friday|Saturday/gi.test(t(this).val())&&e.prop("checked",!0).parents(".gs__content-box").find("input[data-shipping-method-label-title]").not(e).prop("checked",!1).prop("disabled",!0).parents(".gs__radio-wrapper").addClass("disabled")}):i.find("input[data-shipping-method-label-title]").each(function(){var e=t(this).attr("id"),n=e.slice(e.length-1);t(this).prop("checked",!1),"0"===n&&t(this).prop("checked",!0).prop("disabled",!1).parents(".gs__radio-wrapper").removeClass("disabled")})})}(),t(".account__container-customer-change-password").on("click",function(e){e.preventDefault();var n=t(".form-recover");n.hasClass("hide")?n.removeClass("hide").find(".submit-message").hide():n.addClass("hide")}),t(".js-form-recover__close").on("click",function(e){e.preventDefault(),t(".form-recover").addClass("hide").find(".submit-message").hide()});var p=".account__container-points-text .points";function f(e){t.each(e,function(e,n){var i=n.description,a=n.points_change,r=n.created_at,o=Math.sign(a),s='\n <tr class="list__item">\n <td class="list__title">'+i+'</td>\n <td class="list__data">'+function(t,e){var n="YYYY:MM:DD:HH:mm:ss".split(":");return(e=new Date(e||Date.now()-6e4*(new Date).getTimezoneOffset())).toISOString().split(/[-:.TZ]/).reduce(function(t,e,i){return t.split(n[i]).join(e)},"MM/DD/YYYY HH:mm:ss")}(0,r)+'</td>\n <td class="list__value">'+a+"</td>\n </tr>\n ";-1===o?t(".negative-points-transactions > tbody").empty().append(s):t(".points-transactions > tbody").append(s)})}t(document).on("sweettooth-ready",function(){var e=SweetTooth,n=e.customer,i=e.customerAuthenticationToken;SweetTooth&&n&&(function(e){t(p).text(e)}(n.points_balance),function(e,n){e&&n&&t.ajax({method:"GET",headers:{Authorization:"Bearer "+n,"Content-Type":"application/json",Accept:"application/json"},url:"https://api.sweettooth.io/v1/points_transactions",data:{customer_id:e}}).done(function(t){var e=t.points_transactions;e&&e.length&&f(e)}).fail(function(t){return console.error(t)})}(n.id,i))}),t(".gs__set-shipping-address").on("click",function(){t(".gs__line-qty").prop("readonly",!0)}),t(".single-option-selector-product-template").on("change",function(){var e=t(".template-product .product-single__meta .price-item--regular"),n=e.attr("data-weight");e.append("/"+n)}),t(".product-video-slider").slick({infinite:!0,speed:500,fade:!0,cssEase:"linear",nextArrow:'<span class="icon-next "></span>',prevArrow:'<span class="icon-prev"></span>'}),t(".category-slider").slick({dots:!1,infinite:!1,slidesToShow:3,slidesToScroll:1,speed:300,responsive:[{breakpoint:769,settings:{slidesToShow:2}},{breakpoint:550,settings:{slidesToShow:1}}]}),t(".show-video").on("click",function(e){e.preventDefault();var n=t(this).parent().find(".category-slider__featured-image").attr("data-url"),i=t(this).parent().find(".article__title").text().trim();t("#videoBlogLightbox").addClass("open-video").append('<iframe src="'+n+'" title="'+i+'" class="video-iframe" frameborder="0" width="918px" height="519px" allow="autoplay; encrypted-media" allowfullscreen></iframe>'),t("body").addClass("overflow-hidden")}),t("#closeButton").on("click",function(){t("#videoBlogLightbox").removeClass("open-video").find(".video-iframe").remove(),t("body").removeClass("overflow-hidden")}),t("#Subscribe").on("click",function(){SweetTooth.createActivity({activity_type:"activity_kmrwqCs55TDncNplg2T4mN5Q"}).then(function(t){console.log("Created activity "+t.id)}).catch(function(t){console.log("Something went wrong.")})});var h=t(".product-single__vacuum-input"),v=h.val(),m=t(".product-form__cart-submit");/*m.on("click",function(e){e.preventDefault();var cartAddUpdate=new CustomEvent("cartAddUpdate");document.dispatchEvent(cartAddUpdate);h.prop("checked")?t.ajax({type:"POST",url:"/cart/add.js",data:{quantity:1,id:v},dataType:"json",success:function(){m.off().trigger("click")},error:function(){}}):m.off().trigger("click")});*/var g=t(".vacuum_text span"),_=t(".all-price"),w=t(".cart"),b=w.find(".line-row").data("line-row"),y=w.find(".line-row").data("first-id"),x=w.find(".line-row").data("last-id"),k=new Date,j=k.getFullYear()+"-"+(k.getMonth()+1)+"-"+k.getDate(),T=0;function S(e,n){var i;t.ajax({type:"POST",url:"/cart/update.js",data:{updates:(i={},r(i,e,0),r(i,n,1),i)},dataType:"json",success:function(){if(!document.querySelector('[data-vacumm-sealing]'))window.location.reload()},error:function(){}})}if(t.each(_,function(){T+=parseFloat(t(this).data("all-price"))}),void 0!==b&&t.ajax({type:"POST",url:"/cart/change.js",data:{line:b,quantity:1},dataType:"json",success:function(){},error:function(){}}),t(".cart__row").each(function(){var e=t(this).find(".cart__container-product-title").data("title"),n=t(this).find(".vacuum_text").data("vacuum-price"),i=t(this).data("id");"vacuum-sealing"===e&&0===n?t(this).find(g).text("Your order is eligible for free vacuum sealing."):t(this).find(g).text("Due to the increased cost of supplies and labor, we can no longer offer free vacuum sealing. All orders will be charged $25.00"),i===y&&T>=200&&S(y,x),i===x&&T<200&&S(x,y)}),t(".cart__remove").on("click",function(e){e.preventDefault();var n=t(this).parents(".cart__row"),i = n.data("line-key"),a = n.data("portioned"),o = 1 === t('[data-portioned]').length,s=t("[data-first-id]").length,c=r({},i,0);a&&o&&s&&(c[y]=0,c[x]=0);var cartRemoveUpdate=new CustomEvent("cartRemoveUpdate", {detail: c});document.dispatchEvent(cartRemoveUpdate)}),void 0!==pf_gs_show_shipping&&pf_gs_show_shipping)var C=0,O=setInterval(function(){var e=t(".gs__shipping-name");(C+=1)>=30&&clearInterval(O),e.length&&(clearInterval(O),e.each(function(){var e=t(this),n=e.text();n.includes("Friday")&&n.includes("Saturday")&&(e.parents("fieldset.gs__content-box").css("min-height","auto"),e.parents(".gs__radio-wrapper").remove())}))},1e3)})},function(t,e,n){t.exports=n.p+"main.css"}]);

  /*
  <input id="{{ product_variants.first.id }}-vacuum" class="product-single__vacuum-input" type="checkbox" name="product_vacuum" value="{{ product_variants.first.id }}">
  */

  $(document).on('change', '.single-option-selector, .product-form__input', function () {
    if($(this).val().indexOf('vacuum sealed') !== -1 && $('.product-single__vacuum-input').length) {
      $('.product-single__vacuum-input').prop( "checked", true );
    } else {
      $('.product-single__vacuum-input').prop( "checked", false );
    }
  });

  $(document).on('click', '.quantity__btn.quantity__inc', function() {
    let q = $(this).parents('.product-card').find('.product-form__input').val(),
        p = 1,
        u = parseInt(q) + parseInt(p);
    theme._updateCta();
    $(this).parents('.product-card').find('.product-form__input').val(u).trigger('change');
  });

  $(document).on('click', '.quantity__btn.quantity__dec', function() {
    var minQty = $(this).attr('data-minqty');
    let q = $(this).parents('.product-card').find('.product-form__input').val(),
        p = 1,
        u = parseInt(q) - parseInt(p);
    theme._updateCta();
    if(parseInt(q) > parseInt(minQty)){
      $(this).parents('.product-card').find('.product-form__input').val(u).trigger('change');
    }
  });


  // Changing PLP and related product button to link to PDP
  // $(document).on('click', '.collection_addtocart', function(event) {
  //   event.preventDefault();

  //   var variantId = $(this).attr('data-vid');
  //   var variantQty = $(this).parents('.product-card').find('.product-form__input').val();

  //   $.ajax({
  //     type: 'post',
  //     url: '/cart/add.js',
  //     dataType: 'json',
  //     data: {
  //       quantity: variantQty,
  //       id: variantId
  //     },
  //     success: function (response) {
  //       window.location.href = '/cart';
  //     }
  //   });
  // });

  $(document).on('click', '.select_prep', function(event) {
    event.preventDefault();
    window.location.href = $(this).attr('data-href') + "/#";
  });
  
  
  $(document).ready(function(){
    $('.blogs-sidebar__nav').removeClass('open');
    $('.blogs-sidebar__list-filter').hide();
    $('.js-sidebar-title').on('click' , function(){
      $('.blogs-sidebar__list-filter').hide();
      $('.blogs-sidebar__nav').removeClass('open')
      $(this).parents('.blogs-sidebar__nav-filter').find('.blogs-sidebar__list').slideToggle();
    });


    $('.homepage__featured-collections').slick({
      dots: true,
      arrows: false,
      infinite: true,
      speed: 2000,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 989,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            dots: true,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
    
    $('.cut-tail li').last().css('border', '0');
    
    $('.moreless-button').click(function() {
      $('.moretext').slideToggle();
      $('.moreless-button').hide();
    });
    
    $('.moreless-button-collections').click(function() {
      $('.moretext-collections').slideToggle();
      $('.moreless-button-collections').hide();
    });

    $(document).on('click', '.klaviyo-bis-trigger', function() {
      var script = `
      <script type="text/javascript">
        $(document).ready(function(){
          $("#klaviyo-bis-iframe").contents().find('.btn-success').click(function(event){
            var email = $("#klaviyo-bis-iframe").contents().find('#email').val();
            if(email != '') {
              $("#klaviyo-bis-iframe").contents().find('#newsletter_subscription').css({'bottom':'auto'});
            }
        });
      });
      </script>
      `;
      //transform: scale(0.9, 1.4);
      //400 40px/1 "GloucesterMT-ExtraCondensed,sans-serif"
      //700 30px/1 "GloucesterMT-ExtraCondensed,sans-serif"
      
      //transform: scale(.6, 1);
      //font: 600 40px/1 "GloucesterMT-ExtraCondensed,sans-serif";
      var css = `
      <style type="text/css">
        .modal-title {
          color: #ec8c58;
          text-align: center;
          text-transform: uppercase;
          font: 400 40px GloucesterMT-ExtraCondensed,sans-serif;
          margin: 25px 0;
          padding-bottom: 10px;
        }
        .modal-title + p, #subscribe_for_newsletter + label {
          color: #5d5d5c;
          text-align: center;
          font-family: Montserrat, sans-serif;
        }
        .klaviyo-bis-close {
          color: #5d5d5c;
        }
        .continue-shopping-link {
          text-transform: uppercase;
          display: flex;
          justify-content: center;
          margin-top: 45px;
          color: #5880a4;
          font-family: Montserrat, sans-serif;
        }
        .continue-shopping-link + .continue-shopping-link {
          display: none;
        }
        #newsletter_subscription {
          position: absolute;
          bottom: 60px;
        }
        .control-group.clearfix.submit-container > button {
          font-size: 18px;
          font-family: Montserrat, sans-serif;
        }
        @font-face { 
          font-family: 'GloucesterMT-ExtraCondensed'; 
          src: url('https://cdn.shopify.com/s/files/1/0126/6076/8825/files/GloucesterMT-ExtraCondensed.ttf?v=1635793380'); 
          font-weight: normal; font-style: normal;
        }
      </style>
      `;
      //https://cdn.shopify.com/s/files/1/0126/6076/8825/files/GloucesterMT-ExtraCondensed.eot
      
      var continue_shopping = `
        <a href="https://www.freshseafood.com/" target="_parent" class="continue-shopping-link">Continue Shopping</a>
      `;
      $("#klaviyo-bis-iframe").contents().find("#klaviyo-bis-modal").css({'opacity':'0'});
      setTimeout(function() {
        $("#klaviyo-bis-iframe").contents().find("#klaviyo-bis-modal").css({'opacity':'1'});
        if(!$("#klaviyo-bis-iframe").contents().hasClass(".continue-shopping-link")) {
          $("#klaviyo-bis-iframe").contents().find("head").append(css); 
          $("#klaviyo-bis-iframe").contents().find(".submit-container").append(continue_shopping);
          $("body").append(script); 
        }
        
      }, 500);
    });
  });

//Responsible for updating cart when item is removed. Triggered by custom event in minified code above
(function() {
  const VACUUM_SEAL_VARIANT_ID = 17880027496505;
  const VACUUM_SEAL_PID = 1816093425721;
  const CENTER_CUT_VARIANT_ID = 41240424775737;
  const serializeFormObject = function($form) {
    var results = {};

    if ($form) {
      var arr = $form.serializeArray();
      for (var i = 0, len = arr.length; i < len; i++) {
        obj = arr[i];
        if (results.hasOwnProperty(obj.name)) {
          if (!results[obj.name].push) {
            results[obj.name] = [results[obj.name]];
          }
          results[obj.name].push(obj.value || '');
        } else {
          results[obj.name] = obj.value || '';
        }
      }
    }
    return results;
  }

  const addCenterCutUpcharge = function(totalQty, isUpdate) {
    return new Promise((resolve, reject) => {
      if (totalQty !== null && totalQty !== undefined) {
        const url = isUpdate ? "/cart/update.js" : "/cart/add.js";
        const payload = isUpdate ? {updates: {[CENTER_CUT_VARIANT_ID]: totalQty}} : {quantity:totalQty, id:CENTER_CUT_VARIANT_ID};
        $.ajax({
          type:"POST",
          url: url,
          data: payload,
          dataType:"json",
          success:function(data){
            return resolve(data)
          },
          error:function(err) {
            return reject(err)
          },
        });
      }
    });

  };

  const addVacuumSeal = function (id, isRemove) {
    const url = isRemove ? "/cart/update.js" : "/cart/add.js";
    const payload = isRemove ? {updates: {[VACUUM_SEAL_VARIANT_ID]: 0}} : {quantity:1, id:VACUUM_SEAL_VARIANT_ID};
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "POST",
        url: url,
        data: payload,
        dataType: "json",
        success: function(data) {
          return resolve(data)
        },
        error: function(err) {
          return reject(err)
        }
      }); 
    });
  };

  const handleCartUpcharges = function (cart) {
    return new Promise((resolve, reject) => {
      (async () => {
        const { items } = cart || {};
        let isVacuumSealed = false;
        let isVacuumSealedAdded = false;
        let centerCutCartQuantity = 0;
        let centerCutOrigQuantity = 0;
        let isCenterCutAdded = false;
        if (items && items.length) {
    
          items.forEach((item) => {
            if (item.properties && item.properties['Packaging Options'] && item.properties['Packaging Options'] !== 'No portioning' && item.properties['Packaging Options'] !== '1 pound no vacuum seal' && item.properties['Packaging Options'] !== '1/2 pound no vacuum seal' && !isVacuumSealed) {
              isVacuumSealed = true;
            }
            if (item.properties && item.properties['Center Cut']) {
              centerCutCartQuantity += item.quantity;
            }
            if (item.product_id === VACUUM_SEAL_PID) {
              isVacuumSealedAdded = true;
            } 
            if (item.variant_id === CENTER_CUT_VARIANT_ID) {
              centerCutOrigQuantity = item.quantity;
              isCenterCutAdded = true;
            }
          });
          //handle adding vacuum seal
          if (isVacuumSealed && !isVacuumSealedAdded) {
            const vacSealUpdated = await addVacuumSeal(null, isVacuumSealedAdded).catch((err)=>{console.log(err)})
          }
          //handle removing vacuum seal
          if (!isVacuumSealed && isVacuumSealedAdded) {
            const vacSealUpdated = await addVacuumSeal(null, isVacuumSealedAdded).catch((err)=>{console.log(err)})
          }
          if (centerCutOrigQuantity != centerCutCartQuantity) {
            const centerCutUpdated = await addCenterCutUpcharge(centerCutCartQuantity, isCenterCutAdded).catch((err)=>{console.log(err)})
          }
        }
        resolve({
          vacuumSealUpdated: isVacuumSealed && !isVacuumSealedAdded ? true : false,
          centerCutAdded: centerCutCartQuantity && centerCutOrigQuantity != centerCutCartQuantity ? true : false
        })
      })()
    });
  };

  const processCart = function () {
    return new Promise((resolve, reject) => {
      fetch('/cart.js')
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          return {}
        }
      })
      .then(async (data) => {
        if (data.success == false) {
          reject(data);
        } else {
          const handleResp = await handleCartUpcharges(data)
          resolve(handleResp);
        }
      });
    });
  };

  document.addEventListener('cartRemoveUpdate', (e) => {
    var updateObject = e && e.detail;
    if (updateObject) {
      $.ajax({
        type: "POST",
        url: "/cart/update.js",
        data: { updates: updateObject },
        dataType: "json",
        success: function () {
          (async () => {
            await processCart()
            window.location.reload();
          })()
        },
        error: function () {},
      });
    }
  })

  $(document).on('click', '.product-form__cart-submit', (e) => {
    e.preventDefault();
    var $form = $(e.target).closest('form[action="/cart/add"]');
    var isGiftWizardButton = $(e.target).hasClass('GiftWizard-gift-button'); 
    if (!isGiftWizardButton) {
      $.ajax({
          type: "POST",
          url:"/cart/add.js",
          dataType:"json",
          data: serializeFormObject($form), // serializes the form's elements.
          success: function(data){
            processCart()
            .then((data)=> {
              if (window.location.pathname != '/cart') {
                window.location.href = 'https://www.freshseafood.com/cart';
              }
            })
              .catch((e)=>{console.log('e: ', e)})
          },
          error:function(err){console.log(err)}
      });
    }
  });

  if (window.location.pathname == '/cart') {
    processCart()
    .then((data)=> {
      if (data && (data.centerCutAdded || data.vacuumSealUpdated)) {
        window.location.reload();
      }
    })
    .catch((e)=>{console.log('e: ', e)})
  }
})();